import { UserInfo } from '@/types';
import useUserInfoStore from '@/store/UserInfoStore';
import appStateUpdator from '@/store/AppStateUpdator';

const userInfoService = {
    saveUserInfo(userInfo: UserInfo) {
        const userInfoStore = useUserInfoStore();
        userInfoStore.saveUserInfo(userInfo);
    },
    getUserInfo() {
        const userInfoStore = useUserInfoStore();

        return userInfoStore.getUserInfo();
    },
    deleteUserInfo() {
        const userInfoStore = useUserInfoStore();
        userInfoStore.deleteUserInfo();
    },
    updateAppState(user: null | UserInfo, logged: boolean, loaded: boolean) {
        appStateUpdator.updateState(user, logged, loaded);
    },
    hasUserInfo() {
        const userInfoStore = useUserInfoStore();

        return userInfoStore.hasUserInfo();
    }
};

export default userInfoService;
